import { useMemo } from 'react';
import { NO, YES } from '../../shared/pickers/AdminYesNoPicker';
import { ACTIVE, INACTIVE } from './UserStatusPicker';
import { isUserActive } from '../api/usersApi';

/** Whether a user matches one filter's chosen values (any of them). */
const MATCHERS = {
	status: (user, values) => values.includes(isUserActive(user) ? ACTIVE : INACTIVE),
	brokerGroups: (user, ids) => user.brokerGroups.some(({ id }) => ids.includes(id)),
	ledgers: (user, ledgers) => ledgers.includes(user.ledger),
	canViewGroup: (user, values) => values.includes(user.canViewGroup ? YES : NO),
};

/**
 * Filters users in the browser by status (active / inactive), broker group (their primary or
 * any other), ledger (their primary broker group's) and Can view group (yes / no). Like the Typesense filters in the
 * CRM tables: several values in one filter match any of them, and different filters must
 * all match. Empty filters are ignored.
 */
export const useUserFilter = (users, filters) =>
	useMemo(() => {
		const activeFilters = Object.keys(MATCHERS).filter((field) => filters[field]?.length);
		if (!activeFilters.length) {
			return users;
		}
		return users.filter((user) =>
			activeFilters.every((field) => MATCHERS[field](user, filters[field])),
		);
	}, [users, filters]);
